import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconChanged = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "icon-changed",
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_2627",
			"data-name": "Path 2627",
			d: "M16,6A10,10,0,1,0,26,16,10,10,0,0,0,16,6Zm0,18.333A8.333,8.333,0,1,1,24.333,16,8.333,8.333,0,0,1,16,24.333Z",
			transform: "translate(-6 -6)",
			fill: "#0473a9"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_2628",
			"data-name": "Path 2628",
			d: "M17.882,19.288A1.182,1.182,0,0,1,16.7,18.106V12.652a1.182,1.182,0,0,1,2.364,0v5.455a1.182,1.182,0,0,1-1.182,1.182Z",
			transform: "translate(-7.882 -7.143)",
			fill: "#0473a9"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_2629",
			"data-name": "Path 2629",
			d: "M19.177,22.884a1.364,1.364,0,1,1-1.364-1.364A1.364,1.364,0,0,1,19.177,22.884Z",
			transform: "translate(-7.855 -8.755)",
			fill: "#0473a9"
		})
	]
});
export default SvgIconChanged;
